export default {"src":"/_next/static/media/0x74b23882a30290451a17c44f4f05243b6b58c76d.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};